<canvas
        (window:keydown)="onKeyDown($event)"
        (window:resize)="debouncedOnResize()"
        [attr.id]="'drawingCanvas-'+pageDrawing.pageId">

</canvas>


@if (textEditable &&
fabricService.getCurrentDrawAction() &&
fabricService.getCurrentDrawAction().drawActionElement === drawActionElements.TEXT) {
    <input
            (blur)="onFocusOut($event)"
            (click)="onClick('input-'+pageDrawing.pageId)"
            (keypress)="exitOnEnter($event)"
            [(ngModel)]="textText"
            [attr.id]="'input-'+pageDrawing.pageId"
            [ngStyle]="{'left.px': clickPosition.x, 'top.px': clickPosition.y}"
            class="fabric-text-form-input"
            placeholder="Text schreiben..."/>
}


@if (showDeleteIcon) {
    <div (tap)="removeSelectedDrawElement()"
         [ngStyle]="{'left.px': deleteIconPosition.x, 'top.px': deleteIconPosition.y}"
         class="delete-drawing-icon grow">
        <i class="fa fa-trash"></i>
    </div>
}


